import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from './logosidebar.png';
import { 
  Home, 
  Sprout, 
  ChevronDown, 
  ChevronRight,
  Leaf,
  Settings,
  BarChart3,
  Users,
  Menu,
   Scale ,
  X
} from 'lucide-react';
import './Sidebar.css';
import { checkAuth } from "../utils/auth";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [cropStagesOpen, setCropStagesOpen] = useState(true);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const token = checkAuth();

  const [activities, setActivities] = useState([]);

  const isActive = (path) => location.pathname === path;
  const isStageActive = (path) => location.pathname.startsWith(path);

  useEffect(() => {
    if (!token) return;

    fetch(" https://sadaatagrofarms.com/api/crop_stages/booting/", {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setActivities(data);
      })
      .catch((err) => console.error("Booting Fetch Error:", err));

  }, [token]);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  // Logout handler
  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  // Toggle mobile sidebar
  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  return (
    <>
      {/* Mobile Toggle Button */}
      <button className="mobile-toggle-btn" onClick={toggleMobileSidebar}>
        {isMobileOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Overlay */}
      {isMobileOpen && <div className="mobile-overlay" onClick={toggleMobileSidebar}></div>}

      {/* Sidebar */}
      <div className={`sidebar ${isMobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-logo">
         <img src={logo} alt="Farm 24 Logo" style={{ width: '80px', height: '70px' }} />
          <span className="logo-text">SAF</span>
        </div>

        <nav className="sidebar-nav">
          {/* Dashboard */}
          <Link to="/" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
            <Home size={20} />
            <span>Dashboard</span>
          </Link>

          {/* Crop Stages */}
          <div className="nav-section">
            <button 
              className={`nav-item expandable ${isStageActive('/crop-stages') ? 'active' : ''}`}
              onClick={() => setCropStagesOpen(!cropStagesOpen)}
            >
              <BarChart3 size={20} />
              <span>Crop Stages</span>
              {cropStagesOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
            </button>

            {cropStagesOpen && (
              <div className="submenu">
                <Link to="/crop-stages/pre-sowing" className={`submenu-item ${isActive('/crop-stages/pre-sowing') ? 'active' : ''}`}>Pre-Sowing</Link>
                <Link to="/crop-stages/sowing-emergence" className={`submenu-item ${isActive('/crop-stages/sowing-emergence') ? 'active' : ''}`}>Sowing</Link>
                <Link to="/crop-stages/emergence" className={`submenu-item ${isActive('/crop-stages/emergence') ? 'active' : ''}`}>Emergence</Link>
                <Link to="/crop-stages/growth-tillering" className={`submenu-item ${isActive('/crop-stages/growth-tillering') ? 'active' : ''}`}>Growth & Tillering</Link>
                <Link to="/crop-stages/rosette" className={`submenu-item ${isActive('/crop-stages/rosette') ? 'active' : ''}`}>Rosette Stage</Link>
                <Link to="/crop-stages/booting" className={`submenu-item ${isActive('/crop-stages/booting') ? 'active' : ''}`}>Booting Stage</Link>
              </div>
            )}
          </div>

          {/* Other links */}
          <Link to="/VegetationAnalysis" className={`nav-item ${isActive('/VegetationAnalysis') ? 'active' : ''}`}><Leaf size={20} /><span>Vegetation Analysis</span></Link>
          <Link to="/community" className={`nav-item ${isActive('/community') ? 'active' : ''}`}><Users size={20} /><span>Community</span></Link>
          <Link to="/finance" className={`nav-item ${isActive('/finance') ? 'active' : ''}`}><BarChart3 size={20} /><span>Finance</span></Link>
          <Link to="/budget" className={`nav-item ${isActive('/budget') ? 'active' : ''}`}><Sprout size={20} /><span>Budget</span></Link>
           <Link to="/balancesheat" className={`nav-item ${isActive('/balancesheat') ? 'active' : ''}`}><Scale  size={20} /><span>Balances Sheet</span></Link>
        </nav>

        {/* Logout Button */}
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </>
  );
};

export default Sidebar;